/* ============================================================
   pc-reviews.js — source des avis

   Ploumi code ses 1 496 avis en dur dans un asset de thème
   (window.PLOUMI_REVIEWS). Le SYSTÈME D'AFFICHAGE est reproduit
   à l'identique ; les DONNÉES, non.

   Fabriquer des avis est une pratique commerciale trompeuse
   (art. L121-2 et L121-4 20° du code de la consommation).
   Ce fichier reste donc vide de contenu réel : il définit la
   forme attendue, et les cartes d'aperçu portent un marqueur
   « EXEMPLE » visible.

   Trois façons de le remplir :
     1. Judge.me (offre gratuite) → widget + API publique
     2. Loox / Okendo → avis photo
     3. Export CSV de vos vrais avis → injecté ici au build

   Forme attendue, par handle produit :
     { avg: 4.7, count: 128, share5: 82, reviews: [
         { stars: 5, name: 'M***e', pays: 'France',
           date: '2026-03-14', text: '…', photo: null, verified: true }
     ]}
   ============================================================ */
window.PC_REVIEWS = {
  /* À REMPLIR — un objet par handle produit.
     Exemple de structure, sans données :
     'serum-eclat': { avg: 0, count: 0, share5: 0, reviews: [] }
  */
};

/* Agrégat affiché tant qu'aucune source n'est branchée.
   Mettre `ready: true` une fois les vrais avis injectés :
   les marqueurs « EXEMPLE » disparaissent alors du rendu. */
window.PC_REVIEWS_META = { ready: false, source: null };

(function () {
  'use strict';
  /* Tant que la source n'est pas prête, on marque visiblement
     toute carte d'avis comme exemple non contractuel. */
  if (window.PC_REVIEWS_META.ready) return;
  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.add('pc-reviews-demo');
  });
})();
